import React from "react"
import queryString from "query-string"
import { navigate } from "gatsby"
import "../components/new-home/global.scss"
import "../components/new-home/spacers.scss"
import SearchPageAsideFilter from "../components/new-search-page/search-page-aside"
import SearchPageContentCards from "../components/new-search-page/search-page-content-cards"
import Header from "../components/new-home/header"
import debounce from "../utils/debounce"

export const NewSearchPage = ({ location }) => {
  const query_params = queryString.parse(location.search)
  const [searchValue, setSearchValue] = React.useState("")
  const [jobLocation, setJobLocation] = React.useState({})
  const [job_type, setJobType] = React.useState([])
  const [seniority_level, setSeniorityLevel] = React.useState([])
  const [experienceLevel, setExperienceLevel] = React.useState({
    min: 0,
    max: 5,
  })
  const [salary, setSalary] = React.useState({
    min: "",
    max: "",
  })

  function encodeQueryData(data) {
    const ret = []
    for (let d in data)
      if (Array.isArray(data[d])) {
        for (let dd in data[d]) {
          ret.push(d + "=" + encodeURIComponent(data[d][dd]))
        }
      } else {
        ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]))
      }
    return ret.join("&")
  }

  const handleTextSearchChange = (value, e) => {
    debouncedSearchTextChange(value, e)
  }

  const searchTextChange = value => {
    setSearchValue(value)
    if (!!value) {
      const url = encodeQueryData({ ...query_params, search: value })
      navigate("?" + url)
    } else {
      const url = encodeQueryData({ ...query_params })
      const sr = document.getElementById("search")
      if (sr && query_params.search) {
        setSearchValue(query_params.search)
        sr.value = query_params.search
      }
      navigate("?" + url)
    }
  }

  const debouncedSearchTextChange = React.useCallback(
    debounce(value => {
      return searchTextChange(value)
    }, 1000),
    [searchTextChange]
  )

  const handleLocationChange = value => {
    setJobLocation(value)
    if (value.id) {
      const url = encodeQueryData({
        ...query_params,
        preferred_location: value.id,
      })
      navigate("?" + url)
    } else {
      const { location, ...queryParamsWithoutLocation } = query_params
      const url = encodeQueryData(queryParamsWithoutLocation)
      navigate("?" + url)
    }
  }

  const handleJobTypeChange = value => {
    setJobType(value)

    if (value.length > 0) {
      let jobTypeString = value.map(type => type.id).join(",")

      const url = encodeQueryData({
        ...query_params,
        job_type: jobTypeString,
      })
      navigate("?" + url)
    } else {
      const { job_type, ...queryParamsWithoutJobType } = query_params
      const url = encodeQueryData(queryParamsWithoutJobType)
      navigate("?" + url)
    }
  }

  const handleSeniorityLevelChange = value => {
    setSeniorityLevel(value)

    if (value.length > 0) {
      let query = value.map(type => type.id).join(",")

      const url = encodeQueryData({
        ...query_params,
        seniority_level: query,
      })
      navigate("?" + url)
    } else {
      const {
        seniority_level,
        ...queryParamsWithoutSeniorityLevel
      } = query_params
      const url = encodeQueryData(queryParamsWithoutSeniorityLevel)
      navigate("?" + url)
    }
  }

  const handleSalaryChange = value => {
    setSalary(value)

    if (value.min !== undefined || value.max !== undefined) {
      const updatedParams = {
        ...query_params,
        min_salary: value.min !== undefined ? value.min : undefined,
        max_salary: value.max !== undefined ? value.max : undefined,
      }

      Object.keys(updatedParams).forEach(key => {
        if (updatedParams[key] === undefined || updatedParams[key] === "") {
          delete updatedParams[key]
        }
      })

      const url = encodeQueryData(updatedParams)
      navigate("?" + url)
    } else {
      const {
        min_salary,
        max_salary,
        ...queryParamsWithoutSalary
      } = query_params
      const url = encodeQueryData(queryParamsWithoutSalary)
      navigate("?" + url)
    }
  }

  const handleExperienceChange = value => {
    setExperienceLevel(value)

    if (value.min !== undefined || value.max !== undefined) {
      const updatedParams = {
        ...query_params,
        min_exp: value.min !== undefined ? value.min : undefined,
        max_exp: value.max !== undefined ? value.max : undefined,
      }

      Object.keys(updatedParams).forEach(key => {
        if (updatedParams[key] === undefined || updatedParams[key] === "") {
          delete updatedParams[key]
        }
      })

      const url = encodeQueryData(updatedParams)
      navigate("?" + url)
    } else {
      const { min_exp, max_exp, ...queryParamsWithoutExperience } = query_params
      const url = encodeQueryData(queryParamsWithoutExperience)
      navigate("?" + url)
    }
  }

  // console.log({
  //   job_type: job_type,
  // })

  return (
    <>
      <Header />
      <section className=" wdn-new search__results bg-light-blue py-72px py-lg-132px">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <SearchPageAsideFilter
                query_params={query_params}
                experienceLevel={experienceLevel}
                salary={salary}
                jobLocation={jobLocation}
                seniority_level={seniority_level}
                job_type={job_type}
                handleJobTypeChange={handleJobTypeChange}
                handleSeniorityLevelChange={handleSeniorityLevelChange}
                handleLocationChange={handleLocationChange}
                handleSalaryChange={handleSalaryChange}
                handleExperienceChange={handleExperienceChange}
              />
            </div>
            <div className="col-lg-9">
              <SearchPageContentCards
                experienceLevel={experienceLevel}
                jobLocation={jobLocation}
                salary={salary}
                seniority_level={seniority_level}
                job_type={job_type}
                searchValue={searchValue}
                query_params={query_params}
                handleTextSearchChange={handleTextSearchChange}
                handleJobTypeChange={handleJobTypeChange}
                handleSeniorityLevelChange={handleSeniorityLevelChange}
                handleLocationChange={handleLocationChange}
                handleSalaryChange={handleSalaryChange}
                handleExperienceChange={handleExperienceChange}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
